import Infoblock from 'components/infoblock/infoblock'

export default function NoResults() {
    return <Infoblock className="mb72">Rezultatų nerasta</Infoblock>
}
